import React, { useRef, useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Grid, Navigation, Pagination } from "swiper";
import { textLengthFiltered, shuffleData } from "../utils/common";
import { getPosts } from "../utils/getData";

const Articles = () => {
    const [eatData, setEatData] = useState([]);
    const [liveData, setLiveData] = useState([]);
    const [playData, setPlayData] = useState([]);
    const [buyData, setBuyData] = useState([]);
    const lists = [
        { id: "article_eat", type: "#潮好吃", data: eatData },
        { id: "article_live", type: "#潮好住", data: liveData },
        { id: "article_play", type: "#潮好玩", data: playData },
        { id: "article_buy", type: "#潮好買", data: buyData }
    ];
    const [activeType, setActiveType] = useState(lists[0].id);
    const eatDataParams = {
        tag_name: "刻在心底的台南味＿潮好吃"
    };
    const liveDataParams = {
        tag_name: "刻在心底的台南味＿潮好住"
    };
    const playDataParams = {
        tag_name: "刻在心底的台南味＿潮好玩"
    };
    const buyDataParams = {
        tag_name: "刻在心底的台南味＿潮好買"
    };
    const screenWidth = useRef(window.innerWidth).current;
    const swiperOptions = {
        slidesPerView: screenWidth > 767 ? 4 : 1.89,
        slidesPerGroup: screenWidth > 767 ? 4 : 1,
        spaceBetween: screenWidth > 767 ? 28 : 15.5,
        navigation: screenWidth > 767 ? true : false,
        centeredSlides: screenWidth > 767 ? false : true,
        pagination: screenWidth > 767 ? { clickable: true } : false
    };

    useEffect(() => {
        // 取得潮好吃文章
        getPosts(eatDataParams).then((res) => {
            setEatData(res.data.data.articles);
        });

        // 取得潮好住文章
        getPosts(liveDataParams).then((res) => {
            setLiveData(res.data.data.articles);
        });

        // 取得潮好玩文章
        getPosts(playDataParams).then((res) => {
            setPlayData(res.data.data.articles);
        });

        // 取得潮好買文章
        getPosts(buyDataParams).then((res) => {
            setBuyData(res.data.data.articles);
        });
    }, []);

    return (
        <section id="articles" className="articles">
            <h2
                className="title"
                data-aos="fade-in"
                data-aos-easing="linear"
                data-aos-duration="1000"
            >
                刻在心底的台南味
            </h2>
            <div
                className="description"
                data-aos="fade-in"
                data-aos-easing="linear"
                data-aos-duration="1000"
            >
                <p>
                    吃·住·玩·買，這樣玩！<br />
                    透過深度旅遊，重新認識我們愛的台南！
                </p>
            </div>
            <ul
                className="tab container"
                data-aos="fade-in"
                data-aos-easing="linear"
                data-aos-duration="1000"
                data-aos-delay="500"
            >
                {
                    lists && lists.map((list) => (
                        <li
                            key={list.id}
                            className={`${activeType === list.id ? "active" : ""}`}
                            onClick={(e) => {
                                setActiveType(list.id);
                            }}
                        >
                            <div className={`${list.id} img`}></div>
                            <span>{list.type}</span>
                        </li>
                    ))
                }
            </ul>
            <div
                className="articles-slider container"
                data-aos="fade-in"
                data-aos-easing="linear"
                data-aos-duration="1000"
                data-aos-delay="500"
            >
                <Swiper
                    modules={[Autoplay, Grid, Navigation, Pagination]}
                    slidesPerView={swiperOptions.slidesPerView}
                    slidesPerGroup={swiperOptions.slidesPerGroup}
                    spaceBetween={swiperOptions.spaceBetween}
                    navigation={swiperOptions.navigation}
                    pagination={swiperOptions.pagination}
                    autoplay={{ delay: 5000 }}
                    centeredSlides={swiperOptions.centeredSlides}
                    grid={{
                        rows: 2,
                        fill: "row"
                    }}
                >
                    {
                        lists.map((list) => (
                            list.id === activeType && list.data && shuffleData(list.data).map((item, i) => (
                                <SwiperSlide key={`${list.id}_${item.id}_${i}`} className="item">
                                    <a href={item.link || "#"} target="_blank" rel="noreferrer">
                                        <div className="articles-img">
                                            <img loading="lazy" src={item.image} alt={item.title} />
                                        </div>
                                        <div className="articles-content">
                                            <h3>{textLengthFiltered(item.title, 9)}</h3>
                                            <p>{textLengthFiltered(item.content, 24)}</p>
                                        </div>
                                    </a>
                                </SwiperSlide>
                            ))
                        ))
                    }
                </Swiper>
            </div>
        </section>
    );
};

export default Articles;
